import "./App.css";
import { AppRouter } from "./Routes/router";
import NewVersionBanner from "./Components/UI/NewVersionBanner";

function App() {
  return (
    <div className="App" style={{height: "100vh", overflow: "auto"}}>
      <AppRouter />
      <NewVersionBanner />
    </div>
  );
}

export default App;
